// @flow

import type { Endpoints, EntityFieldCollection, SortParams } from '../types';
import { createdAtField, getCreatedAtSort, idField } from '../abstract/StoredEntity';
import type { StoredEntity } from '../abstract/StoredEntity';
import { constructEndpoints } from '../helpers';
import User from './User';
import OrgLocation from './OrgLocation';

class OrgReview implements StoredEntity {
    static classInternalName = 'org_review';

    static fields: EntityFieldCollection = {
        id: idField,
        createdAt: createdAtField,
        locationId: {
            displayName: 'Location',
            recordName: 'location_id',
            dataType: {
                primitive: 'ref',
                isArray: false,
                extraData: {
                    model: () => OrgLocation,
                    maxValues: 1,
                },
            },
            supportsQuery: true,
            supportsSort: false,
            needToCreate: undefined,
            canEdit: false,
            isOptional: false,
            displayOnMain: true,
        },
        userId: {
            displayName: 'User',
            recordName: 'user_id',
            dataType: {
                primitive: 'ref',
                isArray: false,
                extraData: {
                    model: () => User,
                    maxValues: 1,
                },
            },
            supportsQuery: true,
            supportsSort: false,
            needToCreate: undefined,
            canEdit: false,
            isOptional: false,
            displayOnMain: true,
        },
        title: {
            displayName: 'Title',
            recordName: 'title',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: undefined,
            canEdit: false,
            isOptional: false,
            displayOnMain: true,
        },
        body: {
            displayName: 'Body',
            recordName: 'body',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: undefined,
            canEdit: false,
            isOptional: false,
            displayOnMain: true,
        },
        stars: {
            displayName: 'Stars',
            recordName: 'stars',
            dataType: {
                primitive: 'num',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: undefined,
            canEdit: false,
            isOptional: false,
            displayOnMain: true,
        },
        enabled: {
            displayName: 'Enabled',
            recordName: 'enabled',
            dataType: {
                primitive: 'bool',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: undefined,
            canEdit: true,
            isOptional: false,
            displayOnMain: true,
        },
    };

    static fileFields: EntityFieldCollection = {};

    static defaultSort: SortParams = getCreatedAtSort('created_at');

    get id() {
        return this.record[OrgReview.fields.id.recordName];
    }

    get displayName() {
        return this.record[OrgReview.fields.title.recordName];
    }

    static endpoints: Endpoints = constructEndpoints('organizations/reviews');

    constructor(record: any) {
        this.record = record;
    }
}

export default OrgReview;
